import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			funnel: {
				id: 'ob-female-autotest-check',
				locale: ['en'],
			},
		},
	},
]

export default config
